/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import './styles.scss'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
// import VaccinationGroups from 'components/VaccinationGroups'
import VaccinationCalculator from 'components/VaccinationCalculator'
import { Link } from '@ta-interaktiv/contentbricks'
import GroupChart from 'components/GroupChart'

// TODO Set the correct article ID here
const ARTICLE_ID = '240337209664'

export function AppComponent() {
  return (
    <div className='index'>
      <Masthead articleId={ARTICLE_ID} />
      <ThemeSwitch />

      <header className='ui vertical  very fitted  segment'>
        <div className='ui container'>
          <div className='ui header'>
            <h1>Kann der Bundesrat sein Impfversprechen halten?</h1>
            <h2>
              Bis Ende Juni sollen alle, die das wollen, mindestens einmal
              geimpft sein. Ob das klappen kann, zeigt unser Tool.
            </h2>
          </div>
        </div>
      </header>

      <div className='ui vertical segment'>
        <div className='ui text container'>
          <div className='ta metainfo'>
            <div className='ta author'>Andreas Moor, Marc Brupbacher</div>
          </div>
          {/* <VaccinationGroups /> */}
          <div className='ta text'>
            <p>
              Der Plan der Schweiz sieht vor, dass bis Anfang April alle
              Bewohnerinnen und Bewohner von Pflegeheimen die Zweitimpfung
              erhalten. Bis Ende April sollen alle Personen über 65 Jahre sowie
              Personen mit chronischen Erkrankungen einen Termin für die
              Erstimpfung bekommen. Nach den Risikogruppen folgt der Start des
              Gesundheitspersonals und im Mai der breiten Bevölkerung, in
              welcher jene Vorrang haben, die mit besonders gefährdeten Personen
              zusammenleben (zur{' '}
              <Link href='https://www.bag.admin.ch/dam/bag/de/dokumente/mt/k-und-i/aktuelle-ausbrueche-pandemien/2019-nCoV/impfstrategie-bag-ekif.pdf.download.pdf/COVID-19_Impfstrategie_BAG-EKIF_Stand%2016.12.20.pdf'>
                Impfstrategie des BAG
              </Link>
              ).
            </p>
          </div>
        </div>
      </div>
      <div className='ui text container'>
        <GroupChart />
      </div>
      <div className='ui vertical segment'>
        <div className='ui text container'>
          <div className='ta text'>
            <p>
              Der Bundesrat und das BAG haben mehrfach als Ziel genannt, bis
              30. Juni alle gewillten Bürgerinnen und Bürger{' '}
              <Link href='https://www.tagesanzeiger.ch/liefern-die-hersteller-schneller-als-erwartet-836133528511'>
                mindestens einmal
              </Link>{' '}
              zu impfen und einen Monat später den vollständigen Schutz zu
              ermöglichen. Ist das wirklich realistisch? Finden Sie mit unserem
              Tool heraus, welche Bedingungen dafür erfüllt sein müssten.
            </p>
          </div>
        </div>
      </div>

      <div className='ui text container'>
        <VaccinationCalculator />
      </div>

      <div className='ui vertical segment'>
        <div className='ui text container'>
          <div className='ta text'>
            <p>
              Um das Impfziel bis Sommer zu erreichen, ist zweierlei notwendig.
              Erstens genügend Impfstoff (
              <Link href='https://interaktiv.tagesanzeiger.ch/2020/wo-die-schweiz-im-grossen-impfrennen-steht/'>
                zum Impfmonitor
              </Link>
              ) und eine Infrastruktur in den Kantonen, damit der Impfstoff
              schnell verimpft werden kann. Zudem ist das Tempo auch stark von
              der Impfbereitschaft der Bevölkerung abhängig: Je höher diese ist,
              desto länger dauert es.{' '}
              <Link href='https://covid-norms.ch/'>Eine Umfrage</Link> der
              Universität Zürich zeigt, dass sich aktuell fast 73 Prozent der
              Einwohner in der Schweiz «wahrscheinlich» oder «sehr
              wahrscheinlich» immunisieren lassen wollen (inklusive den bereits
              Geimpften) – so viele wie noch nie seit Beginn der Erhebung.
            </p>
            <p>
              In einem positiven Szenario gibt es keinen Lieferverzug bei
              Moderna und Pfizer und den bis Ende Juli zugesicherten 10,5
              Millionen Dosen. Das Vakzin von AstraZeneca wird im April
              zugelassen, und die Bevölkerung lässt sich trotz den vielen
              Schlagzeilen um das Unternehmen den Impfstoff spritzen. Die bis
              heute noch nicht eingereichten Zulassungsgesuche von Novavax und
              Curevac für ihre Vakzine werden im Mai oder Juni von der
              Heilmittelbehörde Swissmedic bewilligt. Die Kantone zusammen
              können{' '}
              <Link href='https://nzzas.nzz.ch/schweiz/der-schweizer-impfplan-es-wird-eng-ld.1606559'>
                wie versprochen
              </Link>{' '}
              ab Mai über 100’000 Dosen pro Tag verimpfen, und zwar von Montag
              bis Sonntag, und die Impfbereitschaft liegt ungefähr bei 65
              Prozent. Dann wären alle, die das wollen, bis spätestens Ende Juni
              geimpft, sogar vollständig.
            </p>
            <p>
              Ein negatives Szenario würde Lieferverzögerungen bei Moderna oder
              Biontech/Pfizer beinhalten, eine Ablehnung des Impfstoffs von
              AstraZeneca durch die Bevölkerung und einen Zulassungsverzug bei
              den noch ausstehenden Vakzinen. Die täglich verimpfte Menge an
              Dosen würde in der Schweiz daher lediglich 50’000 betragen, nur
              werktags. Wegen einer heftigen dritten Erkrankungswelle steigt die
              Impfbereitschaft aber auf 75 Prozent. Bei dieser Ausgangslage
              wären erst im November alle zweifach geimpft.
            </p>
            <p>
              Gemäss dem BAG besteht bereits rund zwei Wochen nach der ersten
              Dosis ein hoher Schutz vor symptomatischen Infektionen, daher
              könne auch mit einer Dosis ein Einfluss auf den Verlauf der
              Epidemie erwartet werden.
            </p>
          </div>
        </div>
      </div>

      <Footer
        articleId={ARTICLE_ID}
        questions={[
          'Wie informativ war der Beitrag?',
          'Funktionierte die technische Umsetzung?'
        ]}
        credits={[['Konzept & Umsetzung', 'Andreas Moor und Marc Brupbacher']]}
      />
    </div>
  )
}
